import React, { useEffect } from 'react';
import { LogoLoadingIndicator } from '@/components/logo-loading-indicator';
import { PricingCustomersScreen } from '@/experiences/sales-portal/domain/pricing/screens/customers/pricing-customers-screen';
import { SALES_PORTAL_ROUTES } from '@/navigators/routes';
import { SalesPortalStackParams } from '@/navigators/types';
import { StackNavigationProp, StackScreenProps } from '@react-navigation/stack';
import { useBusinessOrganizationPricingConfig } from '@/experiences/sales-portal/blocs/hooks/use-business-organization-pricing-config';
import { useNavigation } from '@react-navigation/native';

type Props = StackScreenProps<
  SalesPortalStackParams,
  typeof SALES_PORTAL_ROUTES.PricingCustomers
>;

export const PricingCustomersScreenWrapper: React.FC<Props> = (props) => {
  const navigation =
    useNavigation<StackNavigationProp<SalesPortalStackParams>>();

  const { loading, error, hasPricingAccess, hasCustomerTableAccess } =
    useBusinessOrganizationPricingConfig();

  useEffect(() => {
    if (!loading && !error && (!hasPricingAccess || !hasCustomerTableAccess)) {
      navigation.replace(SALES_PORTAL_ROUTES.NotFound);
    }
  }, [error, hasCustomerTableAccess, hasPricingAccess, loading, navigation]);

  return loading ? (
    <LogoLoadingIndicator />
  ) : (
    <PricingCustomersScreen {...props} />
  );
};
